const CAREBRIDGE_HOSPITAL_ID = 1283;
const CAREBRIDGE_DEMO_ID = 1249;
export const CAREBRIDGE_HOSPITAL_IDS = [
  CAREBRIDGE_DEMO_ID,
  CAREBRIDGE_HOSPITAL_ID,
];

/** Mirrors IntegrationSource in services/orders/schema/enums.py (department_orders.integration_source). */
export enum IntegrationSource {
  HomecareHomebase = "HOMECARE_HOMEBASE",
  Insurecare = "INSURECARE",
  SynapseFulfill = "SYNAPSE_FULFILL",
  AvitaSftp = "AVITA_SFTP",
}

type CarrierConfig = {
  display: string;
  getTrackingUrl: (trackingCode: string) => string;
};

/** Carrier values matching the DB `carrier` enum. */
export enum Carrier {
  Amazon = "Amazon",
  Averitt = "Averitt",
  FedEx = "FedEx",
  GLS_US = "GLS-US",
  GSO = "GSO",
  Optimacourier = "optimacourier",
  UPS = "UPS",
  USPS = "USPS",
  ExpoNow = "EXP.O NOW",
  UnitedDeliveryService = "uds",
  MedTrans = "MedTrans",
  Saia = "saia-freight",
  PittOhio = "pittohio",
  WalmartLastMile = "Walmart Last Mile",
  EcFirstClass = "ec-firstclass",
  ChinaPost = "china-post",
  OnTrac = "ontrac",
}

export const CARRIER_CONFIG: Record<string, CarrierConfig | undefined> = {
  [Carrier.Amazon]: {
    display: "Amazon",
    getTrackingUrl: (_trackingCode: string) => "",
  },
  [Carrier.Averitt]: {
    display: "Averitt",
    getTrackingUrl: (trackingCode: string) =>
      `https://tools.averitt.com/tracking/trackLTLById?toolTab=track&serviceType=LTL&resultsPageTitle=LTL+Tracking+by+PRO+and+BOL&searchType=LTL&trackPro=${trackingCode}`,
  },
  [Carrier.FedEx]: {
    display: "FedEx",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${trackingCode}`,
  },
  [Carrier.GLS_US]: {
    display: "GLS-USA",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.gls-us.com/trackshipment?TrackingNumbers=${trackingCode}`,
  },
  [Carrier.GSO]: {
    display: "GSO",
    getTrackingUrl: (_trackingCode: string) => "",
  },
  [Carrier.Optimacourier]: {
    display: "Optima Courier",
    getTrackingUrl: (trackingCode: string) =>
      `https://shipoptima.com/tracking/?trackingNumber=${trackingCode}`,
  },
  [Carrier.UPS]: {
    display: "UPS",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.ups.com/track?loc=en_US&requester=QUIC&tracknum=${trackingCode}/trackdetails`,
  },
  [Carrier.USPS]: {
    display: "USPS",
    getTrackingUrl: (trackingCode: string) =>
      `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${trackingCode}`,
  },
  [Carrier.ExpoNow]: {
    display: "EXP.O NOW",
    getTrackingUrl: (trackingCode: string) =>
      `https://go2expo.expeditors.com/anonymous-track/shipments/${trackingCode}/details`,
  },
  [Carrier.UnitedDeliveryService]: {
    display: "United Delivery Service",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.uniteddeliveryservice.com/track/barcode/${trackingCode}`,
  },
  [Carrier.MedTrans]: {
    display: "MedTrans",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.medline.com/shipment/medtrans/track-parcel.jsp?trackingId=${trackingCode}`,
  },
  [Carrier.Saia]: {
    display: "SAIA",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.saia.com/tracing/prostatusbypro.aspx?PRONum1=${trackingCode}`,
  },
  [Carrier.PittOhio]: {
    display: "PITT OHIO",
    // PITT OHIO has no public deep-link that traces by PRO number alone, so we
    // open the Ground trace form; the PRO is shown in the row for the biller to paste.
    getTrackingUrl: (_trackingCode: string) =>
      "https://pittohio.com/myPittOhio/Shipping/Ground/TraceRequest",
  },
  [Carrier.WalmartLastMile]: {
    display: "Walmart Last Mile",
    // Walmart's tracking page needs the Walmart order ID as well as the tracking number.
    getTrackingUrl: (_trackingCode: string) => "",
  },
  [Carrier.EcFirstClass]: {
    display: "CHUKOU1 / EC-FirstClass",
    getTrackingUrl: (trackingCode: string) =>
      `https://ec.chukou1.com/track?track_number=${trackingCode}`,
  },
  [Carrier.ChinaPost]: {
    display: "China Post",
    // China Post has no English tracking page that takes the number in the URL.
    getTrackingUrl: (_trackingCode: string) => "",
  },
  [Carrier.OnTrac]: {
    display: "OnTrac / LaserShip",
    getTrackingUrl: (trackingCode: string) =>
      `https://www.ontrac.com/tracking/?number=${trackingCode}`,
  },
};

/** All known carrier values, for use in dropdowns. */
export const CARRIER_OPTIONS = Object.values(Carrier);
